import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { X, Globe } from 'lucide-react';
import type { NordicCountry } from '../hooks/useNordicComingSoon';

const FLAGS: Record<NordicCountry, string> = {
  sweden: '\u{1F1F8}\u{1F1EA}',
  denmark: '\u{1F1E9}\u{1F1F0}',
  finland: '\u{1F1EB}\u{1F1EE}',
  iceland: '\u{1F1EE}\u{1F1F8}',
};

interface Props {
  country: NordicCountry | null;
  onDismiss: () => void;
}

const NordicComingSoonBanner: React.FC<Props> = ({ country, onDismiss }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (country) {
      requestAnimationFrame(() => setVisible(true));
    } else {
      setVisible(false);
    }
  }, [country]);

  if (!country) return null;

  return (
    <div className={`fixed top-32 left-1/2 -translate-x-1/2 z-mapOverlay transition-all duration-300 ${
      visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-3'
    }`}>
      <div className="bg-[var(--bg-surface)] backdrop-blur-xl border border-[var(--border-secondary)] rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3 max-w-md">
        <div className="w-8 h-8 rounded-xl bg-[var(--bg-surface-alt)] flex items-center justify-center shrink-0">
          <Globe size={16} className="text-sky-400" />
        </div>
        <p className="text-tiny font-bold text-[var(--text-secondary)] flex-1 leading-snug">
          <span className="mr-1.5">{FLAGS[country]}</span>
          {t(`nordic_coming_soon.${country}`)}
        </p>
        <button
          onClick={onDismiss}
          className="shrink-0 text-[var(--text-muted)] hover:text-[var(--text-secondary)] transition-colors p-0.5"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default NordicComingSoonBanner;
